import { useEffect, useMemo, useState } from "react";
import { KanbanBoard } from "../../../Kanban/Kanban";
import { TicketModal } from "../../../Checklist/TicketModal/TicketModal";
import TicketModalMeasuring from "../../../../modules/Measuring/TicketModal";
import { useSearchParams } from "react-router-dom";
import TicketModalAssembly from "../../../Assembly/TicketModal/TicketModalAssembly";
import { TicketViewModel } from "../../../../interfaces";

interface BoardInterfaceProps {
  title: string;
  type: "measuring" | "checklist" | "assemble";
}

export const Board = ({ title, type }: BoardInterfaceProps) => {
  const searchParams = useSearchParams();
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [ticketId, setTicketId] = useState<number>();
  const [ticketPatch, setTicketPatch] = useState<{
    id: number;
    changes: Partial<TicketViewModel>;
  }>();

  const showHideModal = (id?: number) => {
    setShowTicketModal(!showTicketModal);
    setTicketId(id);
  };

  const queryId = useMemo(() => searchParams[0].get("id"), [searchParams]);

  useEffect(() => {
    if (queryId) {
      setShowTicketModal(true);
      setTicketId(Number(queryId));
    }
  }, [queryId]);

  return (
    <>
      <h1>{title}</h1>
      {ticketId && type === "checklist" && (
        <TicketModal
          showTicketModal={showTicketModal}
          setShowTicketModal={setShowTicketModal}
          ticketId={ticketId}
          onTicketUpdate={(id, changes) => setTicketPatch({ id, changes })}
        />
      )}
      {ticketId && ["measuring", "assemble"].includes(type) && (
        <TicketModalMeasuring
          showTicketModal={showTicketModal}
          setShowTicketModal={setShowTicketModal}
          ticketId={ticketId}
          type={type}
        />
      )}
      {ticketId && type === "assemble" && (
        <TicketModalAssembly
          showTicketModal={showTicketModal}
          setShowTicketModal={setShowTicketModal}
          ticketId={ticketId}
        />
      )}
      <KanbanBoard
        type={type}
        onClick={showHideModal}
        ticketPatch={ticketPatch}
      />
    </>
  );
};
